import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, capturePromptEvent } from "@/utils/pwa";
import { initNotificationSoundBridge } from "@/utils/notificationSounds";

// iter-232.4 — Fail-loud guard for the marketplace API origin.
//
// 33+ React modules use `process.env.REACT_APP_BACKEND_URL || ''` to
// resolve the API base. If the build pipeline ever fails to inject the
// env var, every fetch silently degrades to a relative URL — which on
// a Shopify-embedded surface or behind a CDN resolves to the WRONG
// origin and returns 404 HTML (same bug class as the ETA App Block,
// iter-232.3). Asserting at module-init time turns a silent class of
// production bugs into an unmissable boot failure during QA.
if (!process.env.REACT_APP_BACKEND_URL) {
  // Render a visible failure rather than letting a blank-screen ship.
  const el = document.getElementById("root");
  if (el) {
    el.innerHTML = (
      '<div style="font-family:system-ui;padding:32px;max-width:640px;margin:64px auto;border:1px solid #ef4444;border-radius:8px;background:#fef2f2;color:#991b1b">' +
      '<h1 style="margin:0 0 8px;font-size:18px">Build configuration error</h1>' +
      '<p style="margin:0">REACT_APP_BACKEND_URL was not injected at build time. ' +
      'Every API call would silently 404 against the wrong origin. ' +
      'Re-deploy with the env var set or contact Emergent Support.</p>' +
      '</div>'
    );
  }
  throw new Error("REACT_APP_BACKEND_URL missing at build time");
}

// PWA: register the push service worker and start listening for install events.
// These are safe to call in any environment; they no-op on unsupported browsers.
registerServiceWorker();
capturePromptEvent();
initNotificationSoundBridge();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
